import { connect } from 'react-redux';
import StepFour from 'views/register/stepFour/StepFour';
import { getLoginRequest, userRegistrationBegin } from 'store/actions/auth.actions';

const mapDispatchToProps = { 
  loginRequest: getLoginRequest,
  userRegistrationRequest: userRegistrationBegin
};

export default connect(null, mapDispatchToProps)(StepFour);
